import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  CardBody,
  CardHeader,
  Checkbox,
  Col,
  Icon,
  PageLoader,
  Row,
  Table,
  useToggle,
} from '@met/react-components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { ApiApplicationTokenModal, PageHeader } from '../../components';
import { apiApplicationsActions } from '../../store';
import AddApiApplicationModel from './components/AddApiApplicationModal';

const applicationColumns = {
  name: {
    label: 'Name',
  },
  actions: {
    label: 'Actions',
    content: application => (
      <Link to={`/apiApplications/${application.id}`}>
        <Icon type='pencil' />
      </Link>
    ),
  },
};

const ApiApplications = () => {
  const dispatch = useDispatch();
  const apiApplications = useSelector(
    state => state.apiApplications.applications
  );
  const apiApplicationsLoading = useSelector(
    state => state.apiApplications.getApiApplications.isLoading
  );
  const newApplication = useSelector(
    state => state.apiApplications.newApplication
  );

  const [showDeleted, setShowDeleted] = useState(false);

  const [addAppHidden, toggleAddAppModal] = useToggle(true);
  const [tokenHidden, toggleTokenModel] = useToggle(true);

  const saveNewApplication = useCallback(
    name => {
      return dispatch(apiApplicationsActions.create(name)).then(() => {
        toggleAddAppModal();
        toggleTokenModel();
        dispatch(apiApplicationsActions.getList(showDeleted));
      });
    },
    [dispatch, toggleAddAppModal, toggleTokenModel, showDeleted]
  );

  useEffect(() => {
    dispatch(apiApplicationsActions.getList(showDeleted));
  }, [dispatch, showDeleted]);

  return (
    <div>
      <PageHeader title='Milwaukee Intl - API Applications' />
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <span>
                <FontAwesomeIcon icon='code' /> API Applications
              </span>
              <div style={{ marginLeft: 'auto' }}>
                <Checkbox
                  checked={showDeleted}
                  onCheck={x => setShowDeleted(x.checked)}
                  label={'Show Deleted'}
                />
              </div>
              <div style={{ marginLeft: 'auto' }} id='table-actions' />
            </CardHeader>
            <CardBody>
              {apiApplicationsLoading ? (
                <PageLoader />
              ) : (
                <Table
                  striped
                  borderless
                  columns={applicationColumns}
                  data={apiApplications}
                  actionsToolbar={{
                    targetElementId: 'table-actions',
                    customActions: [
                      {
                        label: 'Add Application',
                        icon: <Icon type='plus-circle' />,
                        onClick: toggleAddAppModal,
                      },
                    ],
                  }}
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <AddApiApplicationModel
        hidden={addAppHidden}
        toggle={toggleAddAppModal}
        onSaveClick={saveNewApplication}
      />
      <ApiApplicationTokenModal
        hidden={tokenHidden}
        toggle={toggleTokenModel}
        token={newApplication.apiToken}
      />
    </div>
  );
};

export default ApiApplications;
